var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket",
    transform: "translate(19.5 -1.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72130",
    "data-name": "Group 72130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91644",
    "data-name": "Path 91644",
    d: "M16.5,6v.75m0,3v.75m0,3v.75m0,3V18m-9-5.25h5.25M7.5,15h3M3.375,5.25A1.125,1.125,0,0,0,2.25,6.375V9.4a3,3,0,0,1,0,5.2v3.026A1.125,1.125,0,0,0,3.375,18.75h17.25a1.125,1.125,0,0,0,1.125-1.125V14.6a3,3,0,0,1,0-5.2V6.375A1.125,1.125,0,0,0,20.625,5.25Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.6b44e48fea6af7f7ba2a3c35daa3cd96.svg";
export { ForwardRef as ReactComponent };